import { useState } from "react";
import { Button } from "@material-ui/core";
import { AssessmentOutlined } from "@material-ui/icons";

import RequestRedoAnalysisDialog from "./request.redo.analysis.dialog.component";

const RequestRedoAnalysisButton = ({ request, setAlert, variant = 'contained' }) => {

    const [isModalOpen, setIsModalOpen] = useState(false);

    const openModal = () => {
        setIsModalOpen(true);
    }

    const closeModal = () => {
        setIsModalOpen(false);
    }

    const handleClick = () => {
        openModal();
    }

    const getButton = () => ({
        contained: (
            <Button
                variant="contained"
                color="primary"
                startIcon={<AssessmentOutlined />}
                onClick={handleClick}
            >
                Análise do Refazimento
            </Button>
        ),
        link: (
            <Button
                variant='text'
                color='primary'
                className="w-full"
                onClick={handleClick}
            >
                <span className='text-sm'>Análise do Refazimento</span>
            </Button>
        )
    })[variant];

    return (
        <>
            {getButton()}

            <RequestRedoAnalysisDialog
                request={request}
                isOpen={isModalOpen}
                onClose={closeModal}
                setAlert={setAlert}
            />
        </>
    )
}

export default RequestRedoAnalysisButton;
